(() => {
  const stars = (rating) => "★".repeat(rating) + "☆".repeat(5 - rating);
  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  let lightbox;
  let lightboxImages = [];
  let lightboxIndex = 0;
  let lightboxTrigger;
  const updateLightbox = () => {
    if (!lightbox || !lightboxImages.length) return;
    const image = lightbox.querySelector("[data-review-lightbox-image]");
    image.src = lightboxImages[lightboxIndex];
    image.alt = `Customer review photo ${lightboxIndex + 1} of ${lightboxImages.length}`;
    lightbox.querySelector("[data-review-lightbox-count]").textContent =
      `${lightboxIndex + 1} / ${lightboxImages.length}`;
    lightbox
      .querySelectorAll("[data-review-lightbox-direction]")
      .forEach((button) => {
        button.hidden = lightboxImages.length < 2;
      });
  };
  const moveLightbox = (direction) => {
    lightboxIndex =
      (lightboxIndex + direction + lightboxImages.length) %
      lightboxImages.length;
    updateLightbox();
  };
  const ensureLightbox = () => {
    if (lightbox) return lightbox;
    lightbox = create("dialog", "kbd-review-lightbox");
    lightbox.setAttribute("aria-label", "Customer review photos");
    lightbox.innerHTML =
      '<div class="kbd-review-lightbox__frame"><div class="kbd-review-lightbox__viewer"><button class="kbd-review-lightbox__nav kbd-review-lightbox__nav--previous" type="button" data-review-lightbox-direction="-1" aria-label="Previous image">‹</button><div class="kbd-review-lightbox__media"><img class="kbd-review-lightbox__image" data-review-lightbox-image alt=""><button class="kbd-review-lightbox__close" type="button" aria-label="Close image viewer">×</button></div><button class="kbd-review-lightbox__nav kbd-review-lightbox__nav--next" type="button" data-review-lightbox-direction="1" aria-label="Next image">›</button></div><footer class="kbd-review-lightbox__footer"><span class="kbd-review-lightbox__count" data-review-lightbox-count></span></footer></div>';
    document.body.append(lightbox);
    lightbox.querySelector(".kbd-review-lightbox__close").addEventListener(
      "click",
      () => lightbox.close(),
    );
    lightbox
      .querySelectorAll("[data-review-lightbox-direction]")
      .forEach((button) =>
        button.addEventListener("click", () =>
          moveLightbox(Number(button.dataset.reviewLightboxDirection)),
        ),
      );
    lightbox.addEventListener("click", (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft" && lightboxImages.length > 1)
        moveLightbox(-1);
      if (event.key === "ArrowRight" && lightboxImages.length > 1)
        moveLightbox(1);
      if (event.key === "Escape") lightbox.close();
    });
    lightbox.addEventListener("close", () => {
      lightboxImages = [];
      lightboxTrigger?.focus();
      lightboxTrigger = null;
    });
    return lightbox;
  };
  const openLightbox = (urls, index, trigger) => {
    const viewer = ensureLightbox();
    lightboxImages = urls;
    lightboxIndex = index;
    lightboxTrigger = trigger;
    updateLightbox();
    viewer.showModal();
  };
  const render = (root, data) => {
    root.querySelector("[data-review-summary]").textContent = data.count
      ? `${data.average} / 5 · ${data.count} review${data.count === 1 ? "" : "s"}`
      : "No reviews yet";
    const list = root.querySelector("[data-review-list]");
    list.replaceChildren();
    if (!data.reviews.length) {
      list.append(
        create(
          "div",
          "kbd-reviews__empty",
          "Be the first to review this product.",
        ),
      );
      return;
    }
    data.reviews.forEach((review) => {
      const card = create("article", "kbd-review");
      const meta = create("div", "kbd-review__meta");
      meta.append(
        create("span", "kbd-review__stars", stars(review.rating)),
        create(
          "time",
          "kbd-review__date",
          new Intl.DateTimeFormat("en-US", { dateStyle: "medium" }).format(
            new Date(review.createdAt),
          ),
        ),
      );
      card.append(meta);
      card.append(create("span", "kbd-review__author", review.authorName));
      if (review.title) card.append(create("h3", "", review.title));
      card.append(create("p", "", review.body));
      if (review.images.length) {
        const images = create("div", "kbd-review__images");
        review.images.forEach((url, index) => {
          const link = create("button");
          link.type = "button";
          link.setAttribute(
            "aria-label",
            `View customer review photo ${index + 1} of ${review.images.length}`,
          );
          const image = create("img");
          image.src = url;
          image.alt = "Customer review photo";
          image.loading = "lazy";
          link.append(image);
          link.addEventListener("click", () =>
            openLightbox(review.images, index, link),
          );
          images.append(link);
        });
        card.append(images);
      }
      list.append(card);
    });
  };
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const dialog = root.querySelector("[data-review-dialog]");
    const form = root.querySelector("[data-review-form]");
    const load = () =>
      fetch(
        `/apps/kbd-notify/reviews?productId=${encodeURIComponent(root.dataset.productId)}`,
        { headers: { Accept: "application/json" } },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.ok) render(root, data);
        })
        .catch(() => {
          root.querySelector("[data-review-summary]").textContent =
            "Reviews are temporarily unavailable.";
        });
    load();
    if (!form || !dialog) return;
    const message = root.querySelector("[data-review-message]");
    const files = root.querySelector("[data-review-images]");
    const fileName = root.querySelector("[data-review-file-name]");
    const ratingInputs = Array.from(
      form.querySelectorAll('input[name="rating"]'),
    );
    const ratingScore = root.querySelector("[data-review-rating-score]");
    const updateRatingScore = () => {
      const selected = ratingInputs.find((input) => input.checked);
      ratingScore.textContent = `${selected?.value || 5}.0`;
    };
    ratingInputs.forEach((input) =>
      input.addEventListener("change", updateRatingScore),
    );
    updateRatingScore();
    const updateFileName = (count = 0) => {
      fileName.textContent = count
        ? `${count} ${count === 1 ? fileName.dataset.singular : fileName.dataset.plural}`
        : fileName.dataset.empty;
    };
    root
      .querySelector("[data-review-open]")
      .addEventListener("click", () => dialog.showModal());
    files.addEventListener("change", () => {
      const selected = Array.from(files.files || []);
      const previews = root.querySelector("[data-review-previews]");
      previews.replaceChildren();
      if (
        selected.length > 3 ||
        selected.some((file) => file.size > 1.5 * 1024 * 1024)
      ) {
        files.value = "";
        updateFileName();
        message.dataset.error = "true";
        message.textContent =
          "Choose up to 3 images, no larger than 1.5 MB each.";
        return;
      }
      updateFileName(selected.length);
      selected.forEach((file) => {
        const image = create("img");
        image.src = URL.createObjectURL(file);
        image.alt = "";
        image.onload = () => URL.revokeObjectURL(image.src);
        previews.append(image);
      });
    });
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const button = root.querySelector("[data-review-submit]");
      button.disabled = true;
      message.dataset.error = "false";
      message.textContent = "Submitting…";
      try {
        const formData = new FormData(form);
        const readFile = (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () =>
              resolve({ name: file.name, data: reader.result });
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        const payload = {
          productId: formData.get("productId"),
          rating: formData.get("rating"),
          anonymous: formData.get("anonymous"),
          title: formData.get("title"),
          body: formData.get("body"),
          website: formData.get("website"),
          images: await Promise.all(
            Array.from(files.files || []).map(readFile),
          ),
        };
        const body = new URLSearchParams({
          productId: String(payload.productId || ""),
          rating: String(payload.rating || ""),
          anonymous: String(payload.anonymous || ""),
          title: String(payload.title || ""),
          body: String(payload.body || ""),
          website: String(payload.website || ""),
          imagesJson: JSON.stringify(payload.images),
        });
        const response = await fetch("/apps/kbd-notify/reviews", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Accept: "application/json",
          },
          body,
        });
        const data = await response.json();
        message.dataset.error = String(!data.ok);
        message.textContent = data.message;
        if (data.ok) {
          form.reset();
          updateRatingScore();
          updateFileName();
          root.querySelector("[data-review-previews]").replaceChildren();
          setTimeout(() => dialog.close(), 1800);
        }
      } catch {
        message.dataset.error = "true";
        message.textContent =
          "The review could not be submitted. Please try again.";
      } finally {
        button.disabled = false;
      }
    });
  };
  const initialize = () =>
    document.querySelectorAll("[data-kbd-reviews]").forEach(init);
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", initialize);
  else initialize();
  document.addEventListener("shopify:section:load", initialize);
})();
